module.exports = __webpack_public_path__ + "static/media/foto@2x.2fc24478.jpg";